import { render, staticRenderFns } from "./NextIdsMaintenance.vue?vue&type=template&id=01cc7ffe"
import script from "./NextIdsMaintenance.vue?vue&type=script&lang=ts"
export * from "./NextIdsMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports